import { render, staticRenderFns } from "./logistShore.vue?vue&type=template&id=1b246534"
import script from "./logistShore.vue?vue&type=script&lang=js"
export * from "./logistShore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports